import React from "react";
import Head from "next/head";
import { Container, Heading, Content, ReactMarkdown } from "./styles";
import { Title } from "../../styles/authCommonStyles";
import { PRIVACY_POLICY } from "./legalData";

const PrivacyPage = () => (
  <>
    <Head>
      <title>Privacy Policy — Kic</title>
    </Head>
    <Container>
      <Title>Legal</Title>
      <Content>
        <Heading>PRIVACY POLICY</Heading>
        <ReactMarkdown>{PRIVACY_POLICY}</ReactMarkdown>
      </Content>
    </Container>
  </>
);

export default PrivacyPage;
